import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// http://stackoverflow.com/questions/35284988/angular-2-404-error-occur-when-i-refresh-through-browser

//import { Http, HttpModule, RequestOptions, XHRBackend } from '@angular/http';
//import { HttpService } from './service/HttpService';
import { GlobalService } from './service/globalService';
//import { HttpFactory } from './service/HttpFactory';
import { AdalService, AdalGuard, AdalInterceptor } from 'adal-angular4';
import { SecretService } from './service/secret.service';
import { AppRoutesModule } from './app-routes.module';
import { AppComponent } from './app.component';
import { LoginModule } from './login/login.module';
import { AccessGuardModule } from './access-guard/access-guard.module';
import { BlockScreenModule } from './block-screen/block-screen.module';
//import { GrowlModule } from 'primeng/primeng';
import { ToastModule } from 'primeng/toast';
//import {OAuthModule} from 'angular-oauth2-oidc'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import config from './app.config';
import { AuthGuard } from "./auth"

import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
// import { CorsInterceptor } from './shared/interceptor/cors-interceptor';
//import { HomeComponent } from './home/home.component';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { customOAuthStorage } from './service/customOAuthStorage';
@NgModule({
  declarations: [
    AppComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    // HttpModule,
    AppRoutesModule,
    LoginModule,
    BlockScreenModule,
    AccessGuardModule,
    OAuthModule.forRoot(),
    HttpClientModule,
    //GrowlModule,
    ToastModule,
    TableModule,
    // OktaAuthModule
  ],
  providers: [GlobalService,
    { provide: OAuthStorage, useClass: customOAuthStorage },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
   // { provide: OAuthStorage, useValue: localStorage },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: CorsInterceptor,
    //   multi: true
    // },
    // {
    //   provide: Http,
    //   useFactory: HttpFactory,
    //   deps: [XHRBackend, RequestOptions, GlobalService]
    // },
    AdalService,
    SecretService,
     AuthGuard,
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  
}
